var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_19",
    "data-name": "Ellisse 19",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#dfebf6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company",
    transform: "translate(4.001 3.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_377",
    "data-name": "Tracciato 377",
    d: "M13.71,9.09l3.7.735a.62.62,0,0,1,.5.613V14.72a.629.629,0,0,1-.63.63H13.5a.208.208,0,0,0,.21-.21v-.21h3.569a.211.211,0,0,0,.21-.21V10.438a.211.211,0,0,0-.164-.206L13.71,9.518Z",
    transform: "translate(-7.832 -5.169)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_378",
    "data-name": "Tracciato 378",
    d: "M18.05,14a.21.21,0,0,1,0,.42h-.84a.21.21,0,1,1,0-.42Z",
    transform: "translate(-9.863 -8.018)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_379",
    "data-name": "Tracciato 379",
    d: "M18.05,17a.21.21,0,0,1,0,.42h-.84a.21.21,0,1,1,0-.42Z",
    transform: "translate(-9.863 -9.758)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_380",
    "data-name": "Tracciato 380",
    d: "M18.05,20a.21.21,0,0,1,0,.42h-.84a.21.21,0,1,1,0-.42Z",
    transform: "translate(-9.863 -11.499)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_381",
    "data-name": "Tracciato 381",
    d: "M13.42,15.088a.21.21,0,0,1-.42,0V9.21a.223.223,0,0,1,.076-.164A.221.221,0,0,1,13.252,9l.168.034v6.05Z",
    transform: "translate(-7.542 -5.117)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_382",
    "data-name": "Tracciato 382",
    d: "M10.969,23v.21a.208.208,0,0,0,.21.21H9.5a.208.208,0,0,0,.21-.21V23Z",
    transform: "translate(-5.512 -13.239)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_383",
    "data-name": "Tracciato 383",
    d: "M9.05,5a.21.21,0,1,1,0,.42H8.21a.21.21,0,1,1,0-.42Z",
    transform: "translate(-4.641 -2.796)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_384",
    "data-name": "Tracciato 384",
    d: "M9.259,8.21a.208.208,0,0,1-.21.21H8.21a.21.21,0,1,1,0-.42h.84A.208.208,0,0,1,9.259,8.21Z",
    transform: "translate(-4.641 -4.537)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_385",
    "data-name": "Tracciato 385",
    d: "M9.05,11a.21.21,0,1,1,0,.42H8.21a.21.21,0,1,1,0-.42Z",
    transform: "translate(-4.641 -6.277)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_386",
    "data-name": "Tracciato 386",
    d: "M9.05,14a.21.21,0,1,1,0,.42H8.21a.21.21,0,1,1,0-.42Z",
    transform: "translate(-4.641 -8.018)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_387",
    "data-name": "Tracciato 387",
    d: "M4.259,14.21a.208.208,0,0,1-.21.21H3.21a.21.21,0,0,1,0-.42h.84A.208.208,0,0,1,4.259,14.21Z",
    transform: "translate(-1.741 -8.018)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_388",
    "data-name": "Tracciato 388",
    d: "M4.05,5a.21.21,0,0,1,0,.42H3.21a.21.21,0,1,1,0-.42Z",
    transform: "translate(-1.741 -2.796)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_389",
    "data-name": "Tracciato 389",
    d: "M4.05,8a.21.21,0,0,1,0,.42H3.21a.21.21,0,0,1,0-.42Z",
    transform: "translate(-1.741 -4.537)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_390",
    "data-name": "Tracciato 390",
    d: "M4.05,11a.21.21,0,1,1,0,.42H3.21a.21.21,0,1,1,0-.42Z",
    transform: "translate(-1.741 -6.277)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_391",
    "data-name": "Tracciato 391",
    d: "M6.1,17.63a.211.211,0,0,0-.21-.21H4.63a.208.208,0,0,0-.21.21v1.889H4V17.63A.629.629,0,0,1,4.63,17H5.889a.629.629,0,0,1,.63.63v1.889H6.1Z",
    transform: "translate(-2.321 -9.758)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_392",
    "data-name": "Tracciato 392",
    d: "M4.42,23h2.1v.21a.208.208,0,0,1-.21.21H4.21A.208.208,0,0,1,4,23.21V23Z",
    transform: "translate(-2.321 -13.239)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_393",
    "data-name": "Tracciato 393",
    d: "M.735.189l4.614.7a.627.627,0,0,1,.529.621v2.41L5.71,3.887a.221.221,0,0,0-.176.042.223.223,0,0,0-.076.164V1.511a.212.212,0,0,0-.176-.21L.668.6A.116.116,0,0,0,.63.6.2.2,0,0,0,.5.651.2.2,0,0,0,.42.81V9.551a.211.211,0,0,0,.21.21h1.05v.21a.208.208,0,0,0,.21.21H.63A.629.629,0,0,1,0,9.551V.81A.618.618,0,0,1,.223.331.63.63,0,0,1,.735.189Z",
    transform: "translate(0 0)",
    fill: "#0096cc",
    stroke: "#0096cc",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d3f24a68ecda7e1142ab8c671bf05e6e.svg";
export { ForwardRef as ReactComponent };